import { render, staticRenderFns } from "./RegulatoryUpdateAnnouncement.vue?vue&type=template&id=6f3cc676"
import script from "./RegulatoryUpdateAnnouncement.vue?vue&type=script&lang=ts"
export * from "./RegulatoryUpdateAnnouncement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports